<template>
    <!-- 数字化服务 -->
    <div class="digitalize">
        <div class="top-banner-box">
            <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }"></div>
        </div>
        <!-- 解决方案 -->
        <div class="solution">
            <div class="solution-con">
                <div class="solution-left" style=" background-color: rgb(255 255 255 /0.5)">
                    <div class="solution-left-title">
                        特色服务
                        <!-- <div class="sub">解决方案</div> -->
                    </div>
                    <div class="solution-left-num">
                        {{ sum1 }}<span class="unit">个</span>
                    </div>
                    <div class="solution-left-btn">
                        <div class="btnItem btn" v-for="(item, index) in btnList1" :key="index" v-show="index < 7"
                        @click="goDigServiceList('special', item.id)">
                            {{ item.program }}({{ item.count }})
                        </div>
                        <div class="btnItem btn" v-if="btnList1.length > 0" @click="goDigServiceList('special')">
                            更多+
                        </div>
                    </div>
                </div>
                <div class="solution-right" style=" background-color: rgb(255 255 255 /0.5)">
                    <div class="solution-left-title">
                        公共服务
                        <!-- <div class="sub">解决方案</div> -->
                    </div>
                    <div class="solution-left-num">
                        {{ sum2 }}<span class="unit">款</span>
                    </div>
                    <div class="solution-left-btn">
                        <div class="btnItem btn" v-for="(item, index) in btnList2" :key="index" v-show="index < 7"
                        @click="goDigServiceList('common', item.id)">
                            {{ item.program }}({{ item.count }})
                        </div>
                        <div class="btnItem btn" v-if="btnList2.length > 0" @click="goDigServiceList('common')">
                            更多+
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 特色服务 -->
        <div class="feature">
            <div class="digital_title">特色服务</div>
            <div class="feature-con">
                <div class="seeMore" @click="learnMore('special')">查看更多</div>
                <div class="tip">聚焦宁夏优势特色企业，提供细分行业精准解决方案</div>
                <div class="featureItem" v-for="(item, index) in featureList" :key="index">
                    <div class="feature-style">
                        <!-- 第一种形式：左边文字，右边图片或视频。4个字段都展示（标题、描述、优点、图片或视频） -->
                        <div class="feature-style1" v-show="(index + 1) % 3 == 1">
                            <div class="feature-left">
                                <div class="feature-left-top">
                                    <div class="feature-left-top-title">{{ item.title }}</div>
                                    <div class="feature-left-top-intro over-num-lines num5-lines" style="height:120px">
                                        {{ item.introduce }}
                                    </div>
                                    <div class="feature-left-top-keyWord">
                                        <div v-for="(keyWord, i) in item.superiorityList" :key="i" class="keyWord">
                                            <div class="order" />
                                            {{ keyWord.title }}
                                        </div>
                                    </div>
                                    <div class="common-btn">
                                        <div class="btn" @click="detail(item.uuid)">查看详情</div>
                                    </div>
                                </div>
                            </div>
                            <div class="feature-right" style="justify-content:end">
                                <div v-if="item.pic && !item.videoUrl" class="pic"
                                    :style="{ backgroundImage: `url(${item.pic})` }"></div>
                                <div v-else-if="!item.pic && !item.videoUrl" class="emptyBg pic"></div>
                                <div v-else class="video">
                                    <video-player class="video-player vjs-custom-skin" :ref="`videoPlayer+${index}`"
                                        :playsinline="true" :options="item.options" @play="onPlayerPlay($event)"
                                        @pause="onPlayerPause($event)">
                                    </video-player>
                                </div>
                            </div>
                        </div>
                        <!-- 第二种形式：左边图片，右边文字。4个字段都展示（标题、描述、优点、图片或视频） -->
                        <div class="feature-style2" v-show="(index + 1) % 3 == 2">
                            <div class="feature-right" style="justify-content:start">
                                <div v-if="item.pic && !item.videoUrl" class="pic"
                                    :style="{ backgroundImage: `url(${item.pic})` }"></div>
                                <div v-else-if="!item.pic && !item.videoUrl" class="emptyBg pic"></div>
                                <div v-else class="video">
                                    <video-player class="video-player vjs-custom-skin" :ref="`videoPlayer+${index}`"
                                        :playsinline="true" :options="item.options" @play="onPlayerPlay($event)"
                                        @pause="onPlayerPause($event)">
                                    </video-player>
                                </div>
                            </div>
                            <div class="feature-left">
                                <div class="feature-left-top">
                                    <div class="feature-left-top-title">{{ item.title }}</div>
                                    <div class="feature-left-top-intro over-num-lines num5-lines" style="height:120px">
                                        {{ item.introduce }}
                                    </div>
                                    <div class="feature-left-top-keyWord">
                                        <div v-for="(keyWord, i) in item.superiorityList" :key="i" class="keyWord">
                                            <div class="order" />
                                            {{ keyWord.title }}
                                        </div>
                                    </div>
                                    <div class="common-btn">
                                        <div class="btn" @click="detail(item.uuid)">查看详情</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 第三种形式：从上往下——>标题、描述、图片或视频、优点 -->
                        <div class="feature-style3 special-style" v-show="(index + 1) % 3 == 0">
                            <!-- <div class="style3-title">{{ item.title }}</div> -->
                            <!-- <div class="style3-intro over-num-lines num2-lines">
                                {{ item.introduce }}
                            </div> -->
                            <img :src="item.banner" alt="" @click="detail(item.uuid)">
                            <!-- <div class="style3-picOrVideo">
                                <div v-if="item.pic && !item.videoUrl" class="style3-pic"
                                    :style="{ backgroundImage: `url(${item.pic})` }"></div>
                                <div v-else-if="!item.pic && !item.videoUrl" class="emptyBg pic"></div>
                                <div v-else class="style3-video">
                                    <video-player class="video-player vjs-custom-skin" :ref="`videoPlayer+${index}`"
                                        :playsinline="true" :options="item.options" @play="onPlayerPlay($event)"
                                        @pause="onPlayerPause($event)">
                                    </video-player>
                                </div>
                            </div> -->
                            <!-- <div class="style3-keyWord">
                                <div v-for="(keyWord, i) in item.superiorityList" :key="i" class="keyWord">
                                    <div class="order" />
                                    {{ keyWord.title }}
                                </div>
                            </div> -->
                            <!-- <div class="style3-btn" @click="detail(item.uuid)">查看详情</div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 公共服务 -->
        <div class="common">
            <div class="digital_title" style="margin-bottom:30px">公共服务</div>
            <div class="common-con" style="padding-top: 25px">
                <div class="seeMore" style="top:-25px" @click="learnMore('common')">查看更多</div>
                <div class="tip" style="top:-25px">
                    面向全区工业企业提供ERP、供应链管理、EHS管理等公共服务
                </div>
                <div class="commonItem" v-for="(item, index) in commonList" :key="index">
                    <div class="common-style">
                        <!-- 第一种形式：从上往下——>标题、描述、图片或视频-->
                        <div class="common-style1 special-style" v-show="(index + 1) % 2 == 1">
                            <img :src="item.banner" alt="" @click="detail(item.uuid)">
                            <!-- <div class="common-style1-title" style="margin-bottom:0">{{ item.title }}</div>
                            <div class="common-style1-intro over-num-lines num2-lines">
                                {{ item.introduce }}
                            </div>
                            <div class="common-style1-picOrVideo">
                                <div v-if="item.pic && !item.videoUrl" class="common-style1-pic"
                                    :style="{ backgroundImage: `url(${item.pic})` }"></div>
                                <div v-else-if="!item.pic && !item.videoUrl" class="emptyBg pic"></div>
                                <div v-else class="common-style1-video">
                                    <video-player class="video-player vjs-custom-skin" :ref="`commonPlayer+${index}`"
                                        :playsinline="true" :options="item.options" @play="onPlayerPlay($event)"
                                        @pause="onPlayerPause($event)">
                                    </video-player>
                                </div>
                            </div>
                            <div class="common-style1-btn" @click="detail(item.uuid)">
                                查看详情
                            </div> -->
                        </div>
                        <!-- 第二种形式：左边文字，右边图片或视频。4个字段都展示（标题、描述、优点、图片或视频） -->
                        <div class="feature-style1" v-show="(index + 1) % 2 == 0">
                            <div class="feature-right">
                                <div v-if="item.pic && !item.videoUrl" class="pic"
                                    :style="{ backgroundImage: `url(${item.pic})` }"></div>
                                <div v-else-if="!item.pic && !item.videoUrl" class="emptyBg pic"></div>
                                <div v-else class="video">
                                    <video-player class="video-player vjs-custom-skin" :ref="`commonPlayer+${index}`"
                                        :playsinline="true" :options="item.options" @play="onPlayerPlay($event)"
                                        @pause="onPlayerPause($event)">
                                    </video-player>
                                </div>
                            </div>
                            <div class="feature-left">
                                <div class="feature-left-top">
                                    <div class="feature-left-top-title">
                                        {{ item.title }}
                                    </div>
                                    <div class="feature-left-top-intro over-num-lines num5-lines" style="height:120px">
                                        {{ item.introduce }}
                                    </div>
                                    <div class="feature-left-top-keyWord">
                                        <div v-for="(keyWord, i) in item.superiorityList" :key="i" class="keyWord">
                                            <div class="order" />
                                            {{ keyWord.title }}
                                        </div>
                                    </div>
                                    <div class="common-btn">
                                        <div class="btn" @click="detail(item.uuid)">查看详情</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 第三种形式：从上往下——>图片或视频 -->
                        <!-- <div class="common-style3" v-show="(index + 1) % 3 == 0">
                            <div class="common-style3-top">
                                <div v-if="item.pic && !item.videoUrl" class="common-style3-pic"
                                    :style="{ backgroundImage: `url(${item.pic})` }"></div>
                                <div v-else-if="!item.pic && !item.videoUrl" class="emptyBg pic"></div>
                                <div v-else class="common-style3-video">
                                    <video-player class="video-player vjs-custom-skin" :ref="`commonPlayer+${index}`"
                                        :playsinline="true" :options="item.options" @play="onPlayerPlay($event)"
                                        @pause="onPlayerPause($event)">
                                    </video-player>
                                </div>
                            </div>
                            <div class="common-style3-bottom over-num-lines num2-lines">
                                {{ item.introduce }}
                            </div>
                            <div class="common-style1-btn" @click="detail(item.uuid)">
                                查看详情
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 服务流程 -->
        <!-- <div class="flow">
            <div class="digital_title" style="margin-bottom:20px">服务流程</div>
            <div class="animate__animated animate__lightSpeedInLeft flow-con">
                <div v-for="(item, index) in flowList" :key="index" class="flowItem">
                    <i class="el-icon-arrow-right" v-if="index < 4"></i>
                    <div class="flowItem-bg" :style="{ backgroundImage: `url(${item.pic})` }"></div>
                    <div class="flowItem-title">{{ item.title }}</div>
                </div>
            </div>
        </div> -->
        <!-- 测试图片自适应 -->
        <!-- <div class="testImg">
            <img src="../../assets/publicService/home/1.png" alt="">
        </div> -->
        <!-- 底部了解更多 -->
        <div class="learnMore">
            <div class="learnMore-title">跨行业，多场景数字化解决方案</div>
            <div class="learnMore-btn" @click="goDigServiceList()">了解更多</div>
        </div>
    </div>
</template>

<script>
import {
    getDictionaryItem,
    getTypeCount,
    digitalizeInfo,
} from "../../utils/interface"
import { videoPlayer } from "vue-video-player"
import "video.js/dist/video-js.css"
import "vue-video-player/src/custom-theme.css"
export default {
    name: "",
    components: { videoPlayer },
    props: {},
    data() {
        return {
            headerBgUrl: "",
            sum1: " ", // 特色服务解决方案数量
            sum2: " ", // 公共服务解决方案数量
            btnList1: [
                // { program: '', count: '' }
            ],
            btnList2: [
                // { program: '', count: '' }
            ],
            featureList: [
                // {
                //     title: '全流程运营管控平台 FOM（MES)',
                //     pic: require('../../assets/publicService/digitalize/12.png'),
                //     introduce: '通过立体货柜、立体库、AGV硬件设备与SAP、ERP、HR、PLM高度集成，打造了国内装备制造行业示范智能工厂，实现了装配生产作业的智能化运转，实现上下游系统集成，全业务流程与数据打通',
                //     superiorityList: [{ title: '上下游系统打通' }, { title: '全业务流程数据打通' }, { title: '硬件设备与业务系统高度集成' }],
                //     videoUrl: ''
                // },
                // {
                //     title: '全流程运营管控平台 FOM（MES)',
                //     pic: require('../../assets/publicService/digitalize/12.png'),
                //     introduce: '通过立体货柜、立体库、AGV硬件设备与SAP、ERP、HR、PLM高度集成，打造了国内装备制造行业示范智能工厂，实现了装配生产作业的智能化运转，实现上下游系统集成，全业务流程与数据打通',
                //     superiorityList: [{ title: '上下游系统打通' }, { title: '全业务流程数据打通' }, { title: '硬件设备与业务系统高度集成' }],
                //     videoUrl: 'https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-11-25%2Fed61b0036a0b43769ecca69385fe3386.mp4'
                // },
                // {
                //     title: '全流程运营管控平台 FOM（MES)',
                //     pic: require('../../assets/publicService/digitalize/18.png'),
                //     introduce: '通过立体货柜、立体库、AGV硬件设备与SAP、ERP、HR、PLM高度集成，打造了国内装备制造行业示范智能工厂，实现了装配生产作业的智能化运转，实现上下游系统集成，全业务流程与数据打通',
                //     superiorityList: [{ title: '上下游系统打通' }, { title: '全业务流程数据打通' }, { title: '硬件设备与业务系统高度集成' }],
                //     videoUrl: 'https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-11-25%2Fed61b0036a0b43769ecca69385fe3386.mp4'
                // }
            ], // 特色服务List
            commonList: [
                // {
                //     title: '全流程运营管控平台 FOM（MES)',
                //     pic: require('../../assets/publicService/digitalize/12.png'),
                //     introduce: '通过立体货柜、立体库、AGV硬件设备与SAP、ERP、HR、PLM高度集成，打造了国内装备制造行业示范智能工厂，实现了装配生产作业的智能化运转，实现上下游系统集成，全业务流程与数据打通',
                //     superiorityList: [{ title: '上下游系统打通' }, { title: '全业务流程数据打通' }, { title: '硬件设备与业务系统高度集成' }],
                //     videoUrl: ''
                // },
                // {
                //     title: '全流程运营管控平台 FOM（MES)',
                //     pic: require('../../assets/publicService/digitalize/12.png'),
                //     introduce: '通过立体货柜、立体库、AGV硬件设备与SAP、ERP、HR、PLM高度集成，打造了国内装备制造行业示范智能工厂，实现了装配生产作业的智能化运转，实现上下游系统集成，全业务流程与数据打通',
                //     superiorityList: [{ title: '上下游系统打通' }, { title: '全业务流程数据打通' }, { title: '硬件设备与业务系统高度集成' }],
                //     videoUrl: 'https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-11-25%2Fed61b0036a0b43769ecca69385fe3386.mp4'
                // },
                // {
                //     title: '全流程运营管控平台 FOM（MES)',
                //     pic: require('../../assets/publicService/digitalize/18.png'),
                //     introduce: '通过立体货柜、立体库、AGV硬件设备与SAP、ERP、HR、PLM高度集成，打造了国内装备制造行业示范智能工厂，实现了装配生产作业的智能化运转，实现上下游系统集成，全业务流程与数据打通',
                //     superiorityList: [{ title: '上下游系统打通' }, { title: '全业务流程数据打通' }, { title: '硬件设备与业务系统高度集成' }],
                //     videoUrl: 'https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-11-25%2Fed61b0036a0b43769ecca69385fe3386.mp4'
                // }
            ], // 公共服务List
            flowList: [
                {
                    pic: require("../../assets/publicService/digitalize/7.png"),
                    title: "企业诊断",
                },
                {
                    pic: require("../../assets/publicService/digitalize/6.png"),
                    title: "服务商选择",
                },
                {
                    pic: require("../../assets/publicService/digitalize/10.png"),
                    title: "达成协议",
                },
                {
                    pic: require("../../assets/publicService/digitalize/9.png"),
                    title: "项目实施",
                },
                {
                    pic: require("../../assets/publicService/digitalize/8.png"),
                    title: "项目验收",
                },
            ],
            playerOptions: {
                // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: "video/mp4",
                        // src: 'https://zengcai.obs.cn-north-4.myhuaweicloud.com:443/2023-11-25%2Fed61b0036a0b43769ecca69385fe3386.mp4', //你的视频地址（必填）
                        src: "",
                    },
                ],
                poster: "", //你的封面地址
                width: document.documentElement.clientWidth,
                notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                //        controlBar: {
                //          timeDivider: true,
                //          durationDisplay: true,
                //          remainingTimeDisplay: false,
                //          fullscreenToggle: true  //全屏按钮
                //        }
            },
        }
    },
    watch: {},
    computed: {},
    created() {
        this.getOptionsData()
    },
    mounted() {
        window.addEventListener("scroll", this.menu)
        this.getSpecailService()
        this.getCommonService()
        this.getDigitalizeInfo()
    },
    methods: {
        getOptionsData() {
            //顶部背景图
            getDictionaryItem({
                code: "SZHFW_BANNER",
            }).then((res) => {
                if (res != null && res.length > 0) {
                    this.headerBgUrl = res[0].value
                } else {
                    this.headerBgUrl = ""
                }
            })
        },
        // 特色服务分类统计
        getSpecailService() {
            getTypeCount({
                status: "1",
                type: "SPECIAL_SERVICE",
            }).then((res) => {
                if (Object.keys(res).length > 0) {
                    this.btnList1 = res.list
                    this.sum1 = res.tatolCount
                } else {
                    this.btnList1 = []
                    this.sum1 = " "
                }
            })
        },
        // 公共服务分类统计
        getCommonService() {
            getTypeCount({
                status: "1",
                type: "COMMON_SERVICE",
            }).then((res) => {
                if (Object.keys(res).length > 0) {
                    this.btnList2 = res.list
                    this.sum2 = res.tatolCount
                } else {
                    this.btnList2 = []
                    this.sum2 = " "
                }
            })
        },
        // 数字化服务信息查询
        getDigitalizeInfo() {
            digitalizeInfo({
                rec: "1",
                status: "1",
                sort: "1",
                type: "SPECIAL_SERVICE",
            }).then((res) => {
                if (res && res.length > 0) {
                    this.featureList = res
                    this.featureList.forEach((item, index) => {
                        item.options = JSON.parse(JSON.stringify(this.playerOptions))
                        item.options["sources"][0].src = res[index].videoUrl
                    })
                } else {
                    this.featureList = []
                }
            })
            digitalizeInfo({
                rec: "1",
                status: "1",
                sort: "1",
                type: "COMMON_SERVICE",
            }).then((res) => {
                if (res && res.length > 0) {
                    this.commonList = res
                    this.commonList.forEach((item, index) => {
                        item.options = JSON.parse(JSON.stringify(this.playerOptions))
                        item.options["sources"][0].src = res[index].videoUrl
                    })
                    // let curCommon = JSON.parse(JSON.stringify(res))
                    // let curObj = JSON.parse(JSON.stringify(this.playerOptions))
                    // this.commonList = curCommon.map((item,index)=>{
                    //     curObj['sources'][0].src = res[index].videoUrl
                    //     let obj = {...item,options:curObj}
                    //     return JSON.parse(JSON.stringify(obj))
                    // })
                } else {
                    this.commonList = []
                }
            })
        },
        // 数字化服务查看详情
        detail(uuid) {
            let router = this.$router.resolve({
                path: "/digServiceDetail",
                query: {
                    uuid: uuid
                },
            })
            window.open(router.href, "_blank")
        },
        // 点击更多进入服务列表页
        goDigServiceList(type,uuid) {
            let router = this.$router.resolve({
                path: "/digServiceList",
                query: {
                    type: type,
                    uuid: uuid,
                },
            })
            window.open(router.href, "_blank")
        },
        onPlayerPlay(player) { },
        onPlayerPause(player) { },
        // 查看更多
        learnMore(type) {
            let router = this.$router.resolve({
                path: "/digServiceList",
                query:{
                    type
                }
            })
            window.open(router.href, "_blank")
        },
        // 页面滚动
        menu() {
            //这里是pc端
            let scroll = document.documentElement.scrollTop || document.body.scrollTop
            // console.log('scroll  ' + scroll)
            if (scroll > 700) {
                // this.showService = true
            }
        },
    },
}
</script>
<style lang="less" scoped>
@basic-colors: #2d50a1;

.digitalize {
    position: relative;
    top: -80px;

    .emptyBg {
        background: url("../../assets/publicService/empty.jpg") no-repeat center center/100% 100%;
    }

    .over-num-lines {
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
    }

    .num2-lines {
        -webkit-line-clamp: 2;
    }

    .num3-lines {
        -webkit-line-clamp: 3;
    }

    .num5-lines {
        -webkit-line-clamp: 5;
    }

    .top-banner-box {
        // background-color: #f7f8fb;

        .top-banner-img {
            height: 500px;
            width: 100%;
            overflow: hidden;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .digital_title {
        font-size: 28px;
        font-weight: 600;
        text-align: center;
        margin: 20px 0;
        margin-bottom: 50px;
    }

    .common-btn {
        width: 100px;
        height: 30px;
        line-height: 30px;
        background-color: #2d50a1;
        border-radius: 15px;
        color: #fff;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
    }

    // 解决方案
    .solution {
        width: 100%;
        height: 400px;
        // background: url("../../assets/publicService/digitalize/2.png") no-repeat center center/100% 100%;
        overflow: hidden;

        .solution-con {
            width: 1300px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;

            .solution-left,
            .solution-right {
                width: 640px;
                height: 380px;
                border-radius: 16px;
                // box-shadow: 0 0 6px #9999998a;
                border: 1px solid #efefef;
                display: flex;
                flex-flow: column nowrap;
                justify-content: space-between;
                align-items: start;
                padding: 36px 50px;
                box-sizing: border-box;

                .solution-left-title {
                    font-size: 26px;
                    font-weight: 600;

                    .sub {
                        font-size: 22px;
                    }
                }

                .solution-left-num {
                    align-self: center;
                    font-size: 70px;
                    font-weight: 600;
                    color: #2d50a1;

                    .unit {
                        font-size: 22px;
                    }
                }

                .solution-left-btn {
                    width: 280px;
                    height: 140px;
                    display: flex;
                    flex-flow: row wrap;
                    justify-content: start;
                    align-content: start;
                    flex: 1;

                    .btnItem {
                        color: #2d50a1;
                        font-size: 16px;
                        font-weight: 500;
                        text-align: center;
                        width: 124px;
                        height: 30px;
                        line-height: 30px;
                        border: 1px solid #2d50a1;
                        border-radius: 12px;
                        margin: 0 0 5px 10px;
                    }

                    .btn {
                        cursor: pointer;
                    }
                }
            }

            .solution-left {
                background: url("../../assets/publicService/digitalize/3.png") no-repeat right bottom/290px 236px;
            }

            .solution-right {
                background: url("../../assets/publicService/digitalize/4.png") no-repeat right bottom/290px 236px;
            }
        }
    }

    .seeMore {
        position: absolute;
        top: -45px;
        color: #2d50a1;
        font-size: 16px;
        left: calc(50% + 600px);
        transform: translateX(-50%);
        cursor: pointer;
    }

    .tip {
        position: absolute;
        left: 50%;
        top: -45px;
        transform: translateX(-50%);
        color: #44556694;
        margin: 5px;
    }

    /* 特殊处理,图片宽度为1920px */
    .special-style {
        position: relative;
        width: 1920px !important;
        left: -310px;
    }

    // 特色服务
    .feature {
        min-height: 500px;
        overflow: hidden;
        // background-color: #f3f5f9;

        .feature-con {
            width: 100%;
            min-height: 400px;
            position: relative;
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: center;

            .featureItem {
                width: 100%;
                // background-color: #f3f5f9;

                &:nth-of-type(3n + 1) {
                    background-color: #fff;
                }

                .feature-style {
                    width: 1300px;
                    margin: 0 auto;
                }

                /* 特色服务第三种样式 */
                .feature-style3 {
                    //height: 580px;
                    display: flex;
                    flex-flow: column nowrap;
                    justify-content: space-between;
                    align-items: center;
                    overflow: hidden;
                    height: auto;
                    width: 100%;
                    overflow: hidden;

                    img {
                        max-width: 100%;
                        height: auto;
                        display: block;
                    }

                    .style3-title {
                        color: #2d50a1;
                        font-size: 22px;
                        font-weight: 600;
                        margin-top: 20px;
                    }

                    .style3-intro {
                        color: #445566;
                        font-size: 16px;
                        margin: 35px auto;
                    }

                    .style3-picOrVideo {
                        width: 1000px;
                        height: 325px;
                        background: no-repeat center center/100% 100%;
                        display: flex;
                        justify-content: center;

                        &>div {
                            width: 100%;
                            height: 100%;
                        }

                        .style3-pic {
                            background: no-repeat center center/100% 100%;
                            border-radius: 16px;
                        }

                        .style3-video {
                            width: 580px;
                            height: 325px;
                        }
                    }

                    .style3-keyWord {
                        color: #000;
                        width: 1000px;
                        display: flex;
                        flex-flow: row wrap;
                        justify-content: center;
                        align-items: center;

                        .keyWord {
                            width: 250px;
                            display: flex;
                            align-items: center;

                            .order {
                                width: 12px;
                                height: 12px;
                                margin-right: 4px;
                                background: url("../../assets/publicService/digitalize/11.png") no-repeat center center/100% 100%;
                            }
                        }
                    }

                    .style3-btn {
                        width: 100px;
                        height: 30px;
                        line-height: 30px;
                        background-color: @basic-colors;
                        border-radius: 15px;
                        color: #fff;
                        font-size: 14px;
                        text-align: center;
                        margin: 20px auto;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .common,
    .feature {

        .feature-con,
        .common-con {

            .featureItem,
            .commonItem {

                /* 特色服务第一种样式、第二种形式 */
                .feature-style1,
                .feature-style2 {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    width: 100%;

                    .feature-left,
                    .feature-right {
                        width: 640px;
                        height: 400px;
                        display: flex;
                        // border: 1px solid #445;
                    }

                    .feature-left {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: start;
                        height: 325px;

                        .feature-left-top {
                            height: 325px;
                            display: flex;
                            flex-flow: column nowrap;
                            justify-content: space-between;

                            .feature-left-top-title {
                                color: #2d50a1;
                                font-size: 24px;
                                font-weight: 600;
                            }

                            .feature-left-top-intro {
                                color: #445566;
                                font-size: 16px;
                                line-height: 1.5;
                            }

                            .feature-left-top-keyWord {
                                display: flex;
                                align-items: center;
                                color: #000;

                                .keyWord {
                                    width: 33%;
                                    display: flex;
                                    align-items: center;

                                    .order {
                                        width: 12px;
                                        height: 12px;
                                        margin-right: 4px;
                                        background: url("../../assets/publicService/digitalize/11.png") no-repeat center center/100% 100%;
                                    }
                                }
                            }
                        }

                        .feature-left-bottom {
                            .btn {
                                width: 100px;
                                height: 30px;
                                line-height: 30px;
                                background-color: @basic-colors;
                                border-radius: 15px;
                                color: #fff;
                                font-size: 14px;
                                text-align: center;
                                margin-bottom: 32px;
                                cursor: pointer;
                            }
                        }
                    }

                    .feature-right {
                        justify-content: start;
                        align-items: center;

                        .pic {
                            width: 580px;
                            height: 325px;
                            // border: 1px solid #456;
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                            border-radius: 16px;
                        }

                        .video {
                            width: 580px;
                            height: 325px;
                        }
                    }
                }
            }
        }
    }

    // 公共服务
    .common {
        min-height: 500px;
        overflow: hidden;

        .common-con {
            width: 100%;
            min-height: 400px;
            position: relative;
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            align-items: center;

            .commonItem {
                width: 100%;

                &:nth-of-type(2n + 1) {
                    // height: 585px;
                    background: url("../../assets/publicService/digitalize/19.png") no-repeat center center/100% 100%;
                }

                &:nth-of-type(2n + 2) {
                    height: 400px;
                    // background-color: #f4f9ff;
                }

                /*     &:nth-of-type(3n + 5) {
                     background: url("../../assets/publicService/digitalize/25.png") no-repeat center center/100% 100%;
                } */

                .common-style {
                    width: 1300px;
                    height: 100%;
                    margin: 0 auto;
                    position: relative;

                    .common-style1 {
                        display: flex;
                        flex-flow: column nowrap;
                        justify-content: space-between;
                        align-items: center;
                        height: auto;
                        width: 100%;
                        overflow: hidden;

                        img {
                            max-width: 100%;
                            height: auto;
                            display: block;
                        }

                        .common-style1-title {
                            color: #2d50a1;
                            font-size: 22px;
                            font-weight: 600;
                            margin: 20px auto;
                        }

                        .common-style1-intro {
                            color: #445566;
                            font-size: 16px;
                            height: 50px;
                            line-height: 1.5;
                            text-indent: 2em;
                        }

                        .common-style1-picOrVideo {
                            width: 1300px;
                            height: 325px;
                            background: no-repeat center center/100% 100%;
                            display: flex;
                            justify-content: center;

                            .common-style1-pic {
                                width: 1000px;
                                height: 325px;
                                background: no-repeat center center/100% 100%;
                                border-radius: 16px;
                            }

                            .common-style1-video {
                                width: 580px;
                                height: 325px;
                            }
                        }
                    }

                    .common-style3 {
                        display: flex;
                        flex-flow: column nowrap;
                        justify-content: space-between;
                        align-items: center;
                        height: 440px;

                        .common-style3-top {
                            display: flex;
                            justify-content: center;
                            margin-top: 15px;

                            .common-style3-pic {
                                width: 800px;
                                height: 300px;
                                background: no-repeat center center/100% 100%;
                            }

                            .common-style3-video {
                                width: 440px;
                                height: 250px;
                            }
                        }

                        .common-style3-bottom {
                            height: 48px;
                            line-height: 1.5;
                        }
                    }

                    .common-style1,
                    .common-style3 {
                        .common-style1-btn {
                            width: 100px;
                            height: 30px;
                            line-height: 30px;
                            background-color: @basic-colors;
                            border-radius: 15px;
                            color: #fff;
                            font-size: 14px;
                            text-align: center;
                            margin: 0px auto;
                            margin-bottom: 15px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }

    // 服务流程
    .flow {
        height: 300px;
        // border: 1px solid #456;
        overflow: hidden;

        .flow-con {
            width: 1300px;
            height: 190px;
            margin: 0 auto;
            background-color: #fff;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-around;
            align-items: center;

            .flowItem {
                width: 162px;
                height: 187px;
                background: url("../../assets/publicService/digitalize/5.png") no-repeat center center/100% 100%;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .flowItem-bg {
                    width: 55px;
                    height: 50px;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }

                .flowItem-title {
                    color: #fff;
                    font-size: 18px;
                    font-weight: 600;
                    margin-top: 4px;
                }
            }
        }
    }

    // 底部了解更多
    .learnMore {
        width: 100%;
        height: 230px;
        background: url("../../assets/publicService/digitalize/24.png") no-repeat center center/100% 100%;
        overflow: hidden;
        margin-bottom: -80px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .learnMore-title {
            font-size: 30px;
            font-weight: 600;
            margin: 0 auto;
            margin-bottom: 30px;
        }

        .learnMore-btn {
            width: 120px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            color: #fff;
            font-size: 18px;
            font-weight: normal;
            background-color: #2d50a1;
            border-radius: 4px;
            cursor: pointer;
        }
    }

    .testImg {
        height: auto;
        width: 100%;
        overflow: hidden;

        img {
            max-width: 100%;
            height: auto;
            display: block;
        }
    }
}

/deep/ .el-icon-arrow-right:before {
    font-size: 60px;
    font-weight: 600;
    color: #2d50a1;
    position: absolute;
    right: -80px;
    top: 50%;
    transform: translateY(-50%);
}

/deep/ .vjs-custom-skin>.video-js .vjs-big-play-button {
    // width: 72px;
    height: 72px;
    // border-radius: 100% !important;
    z-index: 100;
    //   background-color: #ffffff30;
    background-color: #2d50a1;
    border: solid 2px #2d50a1;
}

/deep/ .vjs-poster {
    background-color: #0000;
}

/deep/ .vjs-custom-skin>.video-js {
    width: 580px;
    height: 325px;
}

/deep/ .vjs-custom-skin>.video-js .vjs-control-bar {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
}

/deep/ .video-js .vjs-tech {
    border-radius: 14px;
}

/deep/ .vjs-custom-skin>.video-js {
    border-radius: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/digitalize/index.vue